interface StampIconProps {
  size?: number
  variant?: 'cream' | 'solid'
}

export function StampIcon({ size = 52, variant = 'cream' }: StampIconProps) {
  const s = size / 52

  if (variant === 'solid') {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="One-Email">
        <rect width={size} height={size} rx={4 * s} fill="#FF6B00" />
        <rect x={5 * s} y={5 * s} width={11 * s} height={8 * s} rx={1.5 * s} fill="#fff" opacity="0.3" />
        <path
          d={`M${7 * s} ${size * 0.53}L${size / 2} ${size * 0.79}L${45 * s} ${size * 0.53}`}
          fill="none" stroke="#fff" strokeWidth={2.2 * s}
          strokeLinecap="round" strokeLinejoin="round"
        />
        <line x1={7 * s} y1={17 * s} x2={size / 2} y2={17 * s}
          stroke="#fff" strokeWidth={1.5 * s} strokeLinecap="round" opacity="0.4" />
        <line x1={7 * s} y1={22 * s} x2={18 * s} y2={22 * s}
          stroke="#fff" strokeWidth={1.2 * s} strokeLinecap="round" opacity="0.25" />
      </svg>
    )
  }

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="One-Email">
      <rect width={size} height={size} rx={4 * s} fill="#FFF5ED" stroke="#FF6B00" strokeWidth={1.2 * s} />
      <rect x={5 * s} y={5 * s} width={11 * s} height={8 * s} rx={1.5 * s} fill="#FF6B00" opacity="0.35" />
      <path
        d={`M${7 * s} ${size * 0.53}L${size / 2} ${size * 0.79}L${45 * s} ${size * 0.53}`}
        fill="none" stroke="#FF6B00" strokeWidth={2.2 * s}
        strokeLinecap="round" strokeLinejoin="round"
      />
      <line x1={7 * s} y1={17 * s} x2={size / 2} y2={17 * s}
        stroke="#FF6B00" strokeWidth={1.5 * s} strokeLinecap="round" opacity="0.35" />
      <line x1={7 * s} y1={22 * s} x2={18 * s} y2={22 * s}
        stroke="#FF6B00" strokeWidth={1.2 * s} strokeLinecap="round" opacity="0.2" />
    </svg>
  )
}
